import React, {memo, useCallback} from "react";
import {
    generateAndUpdateFeedbackReport,
    generateFeedbackReport,
    getFeedbackReport
} from "../../helpers/firebase/firebaseSurveyReport";
import {exportToXLSXFile} from "../../helpers/xlsx/xlsxHelpers";
import {getEventReport} from "../../helpers/firebase/firebaseEventReport";
import {makeStyles} from "@material-ui/core/styles";
import {feedbackReportRef} from "../../config/firebaseConfig";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh'
    },
    button: {
        fontSize: 24
    }
})

const ReportsPage = ({}) => {

    const handleGenerateReport = useCallback(async () => {
        const feedback = await getFeedbackReport()
        const event = await getEventReport()
        exportToXLSXFile(feedback, event)
    }, [])

    const classes = useStyles()

    return (<div className={classes.root}>
        <button className={'yellow-md-button ' + classes.button} onClick={handleGenerateReport}>
            generate report
        </button>
    </div>);
}

export default memo(ReportsPage)